<template>
  <section class="models-page">
    <header>
      <h1>Models</h1>
    </header>
    <p>
      Create, edit or delete language models which can be used for NLP, prompts and other purposes.
    </p>
    <div>
      <div>
        <ul v-if="!configurationsPending && models.length" class="models-list">
          <li v-for="model in models" :key="model.id" class="model-list-item">
            <div>
              {{ model.name }}
            </div>
            <div>
              {{ model.provider }}
            </div>
            <div>
              {{ model.capability }}
            </div>
            <div>
              {{ model.version }}
            </div>
            <div>
              <ul v-if="organizationsCollection.length" class="organizations-list">
                <li v-for="organizationId in getAllowedOrganmiations(model)" :key="organizationId">
                  {{ getOrganizationName(organizationId) }}
                </li>
              </ul>
            </div>
            <div class="action-wrapper">
              <p-button class="action-icon" variant="text" color="primary" @click.stop="edit(model)">&#9998;</p-button>
            </div>
          </li>
        </ul>
      </div>
      <p-button color="primary" type="submit" @click.stop="create">Register Model</p-button>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import Button from '@/components/common/Button';

export default {
  components: {
    'p-button': Button
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      configurationsPending: s => s.nlp.configurationsPending,
      organizationsCollection: s => s.organizations.collection,
      loadingOrganizations: s => s.organizations.isGetCollectionRequestPending,
      modelPermissions: s => s.nlp.modelPermissions,
      models: s => s.nlp.models || []
    })
  },
  async created() {
    await Promise.all([this.$store.dispatch('nlp/getConfigurations'), this.$store.dispatch('organizations/getCollection')]);
  },
  methods: {
    getAllowedOrganmiations(model) {
      return this.modelPermissions.filter(p => p.model === model.id)?.map(p => p.organization) ?? [];
    },
    getOrganizationName(id) {
      return this.organizationsCollection.find(o => o.id === id)?.name ?? 'Unknown Organization';
    },
    async create() {
      this.$router.push({ path: `/models/new` });
    },
    async edit(model) {
      this.$router.push({ path: `/models/${model.id}` });
    }
  }
};
</script>

<style lang="scss" scoped>
.models-page {
  width: 100%;
  padding: 0 0.5rem 0 1rem;
  box-sizing: border-box;

  header {
    padding: 0.5rem 0.5rem 0;
  }
}

h1 {
  color: var(--theme-on-surface);
  font-size: 1.5rem;
  font-weight: 700;
}

h2 {
  color: var(--theme-on-surface-dark);

  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}
h3 {
  color: var(--theme-on-surface-dark);

  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
}

p {
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
}

.models-list {
  width: max-content;
  padding-bottom: 5px;
  min-width: 758px;

  .model-list-item {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 200px 310px 30px;
    border-top: 1px solid var(--theme-highlight);

    > div {
      border-left: 1px solid var(--theme-highlight);
      padding: 0.35rem 0.5rem;
      font-size: 0.85rem;

      &:last-child {
        border-right: 1px solid var(--theme-highlight);
      }

      &.status {
        font-weight: bold;
        justify-self: center;

        &.in-progress {
          color: #f9a825;
        }
        &.failed {
          color: #da2d2d;
        }
        &.completed {
          color: #2e815b;
        }
      }
    }

    .action-wrapper {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }

    .action-icon {
      font-weight: 700;
      color: var(--theme-primary);
      cursor: pointer;
      justify-self: center;
    }

    &:last-child {
      border-bottom: 1px solid var(--theme-highlight);
    }
  }

  .organizations-list {
    display: flex;
    width: 300px;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    gap: 5px;
  }

  .organizations-list li {
    border-radius: 2px;
    background: var(--theme-primary);
    padding: 0.25rem;
  }
}
</style>
